import { render, staticRenderFns } from "./WsExamsFilterModal.vue?vue&type=template&id=255ef81a"
import script from "./WsExamsFilterModal.vue?vue&type=script&lang=js"
export * from "./WsExamsFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports